import { BaseComponent } from 'app/base';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatatableClickEvent } from '@basis/angular-components';
import { HomologacaoCurso } from 'app/entity/homologacao-curso.model';
import { Situacoes } from 'app/entity/enumeraveis';
import { HomologacaoEvento } from 'app/entity/homologacao-evento.model';

@Component({
  selector: 'termo-aceite-LGPD',
  templateUrl: './termo-aceite-lgpd.component.html'
})
export class TermoAceiteLgpdComponent extends BaseComponent {
  
  @Input() controller: string;
  @Input() eventClickLGPD: DatatableClickEvent;

  @Input() visible: boolean;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() obj: any;

  @Input() funcao: string;

  texto;
  fl_termoLGPD: boolean;

  homologacao_atividade: any;

  init() {
    this.fl_termoLGPD = false;
    this.texto = "Declaro ter ciência de que o CFC realiza o tratamento de seus dados de acordo com a sua Política de Privacidade, Lei Geral de Proteção de Dados Pessoais (Lei n.º 13.709, de 14 de agosto de 2018, a qual pode ser consultada a qualquer momento por Você no endereço eletrônico [ https://cfc.org.br/politica-privacidade-app/]";
  }

  close() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.fl_termoLGPD = false;
  }

  aceitarTermoLGPD(event: DatatableClickEvent){
    //regras para atualizar cada tela a flag[
    if(!this.fl_termoLGPD){
      super.showMsg('error', 'Mensagem de Erro', 'Por favor aceitar o termo de aceite da LGPD.')
      return;
    }

    let itemSelecionado = event == null ? null : event.selection;
    switch (this.controller){
      case "gerenciamentoCurso":
            this.service.Atualizar("turma/AtualizarCursoTermoAceiteLGPDCurso", itemSelecionado.id).subscribe(data => {
            let situacao = itemSelecionado.situacao == null ? null : itemSelecionado.situacao.id;
            this.enviarCadastroHomologacao(itemSelecionado, situacao);
            this.close();
        });
        break;
      case "turma":
        //Atualizo o termo da turma que vai ser gerado a prestar_conta
        this.service.Atualizar("turma/AtualizarCursoTermoAceiteLGPD", itemSelecionado.id).subscribe(data => {
          this.observableUtilPanelDoc.setBlockedPanel(true);
          if(this.funcao == "turma_prestar_conta"){
            this.service.Obter("turma/verificarPrazoPorId/", itemSelecionado.id).subscribe(
              item => {
                  this.observableUtilPanelDoc.setBlockedPanel(false);
                  if (item.prazoCapacitadoraAcabou) {
                      this.showMsgWarn(`O Prazo para prestação de contas de turmas de ${item.exercicio} está finalizado`);
                  }
                  else {
                      if (Number(itemSelecionado.id_situacao) !== 12) { return this.showMsgWarn('Para prestar conta, o Curso deve estar deferido.'); }
                      if (!itemSelecionado.aguardando) { return this.showMsgWarn('Não é possível Prestar Conta.'); }
                      const dataFimString = itemSelecionado.data_inicio_fim.split('-')[1];
                      const dataFim = this.gerarData(dataFimString);
                      const anoTurma = dataFim.getFullYear();
                      if (this.ehCapacitadora && (anoTurma == 2019 || anoTurma == 2020) && new Date(new Date().setHours(0, 0, 0, 0)) > new Date(`2025-02-27`))
                          return this.showMsgWarn(`A data limite para prestar contas das turmas de ${anoTurma} é 27/02/2025`);
                      else if (this.ehCapacitadora && (anoTurma != 2019 && anoTurma != 2020) && new Date(new Date().setHours(0, 0, 0, 0)) > new Date(`${anoTurma + 1}-01-15`)) {
                          return this.showMsgWarn(`A data limite para prestar contas das turmas de ${anoTurma} é 15/01/${anoTurma + 1}`);
                      }

                      this.router.navigate(['/atividades/turma/prestar-conta', itemSelecionado.id], { relativeTo: this.activatedRoute });

                  }
              }, err => {
                  super.showMsg('error', 'Mensagem de Erro', `Houve um erro ao verificar o prazo do registro.<br> ${err._body}`)
                  this.observableUtilPanelDoc.setBlockedPanel(false);
              });
          }
          else if (this.funcao == "turma_prestar_conta_homologacao"){
            this.router.navigate(['/atividades/turma/prestar-conta-homologacao', itemSelecionado.id], { relativeTo: this.activatedRoute });
          }
        });
        break;
      case "instrutor":
        this.obj.flg_termoLGPD = true;

        this.confirmacao.confirm({
          header: 'Mensagem de Confirmação',
          message: `Atenção! Ao confirmar esta operação, os dados serão ${this.obj.id == 0 ? 'salvos' : 'atualizados'} na base de dados.<br>Deseja realmente confirmar esta operação?`,
          accept: () => {
              this.observableUtilPanelDoc.setBlockedPanel(true);
              this.obj.id == 0?
                  this.service.Adicionar(this.controller, this.obj).subscribe(() => {
                      this.showMsgSucess('Registro salvo com sucesso.');
                      this.observableUtilPanelDoc.setBlockedPanel(false);
                      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
                  },
                      err => {
                          this.observableUtilPanelDoc.setBlockedPanel(false);
                          if (err.status === 412) {
                              super.showMsgWarn(`Atenção!<br> ${err._body}`)
                              return this.router.navigate(['../'], { relativeTo: this.activatedRoute });
                          }
                          super.showMsgError(`Houve um erro ao salvar o registro.<br> ${err._body}`)
                      }) :
                  this.service.Atualizar(this.controller, this.obj).subscribe(() => {
                      this.showMsgSucess('Registro atualizado com sucesso.');
                      this.router.navigate(['../../'], { relativeTo: this.activatedRoute })
                      this.observableUtilPanelDoc.setBlockedPanel(false);
                  },
                      err => {
                          this.observableUtilPanelDoc.setBlockedPanel(false);
                          this.showMsgError(`Houve um erro ao atualizar o registro.<br> ${err._body}`)
                      });
          }
        });
        break;
      case "prestacaoConta":
        this.service.Atualizar("prestacaoConta/AtualizarTermoAceiteLGPD", this.obj.id).subscribe(data => {
            this.confirmacao.confirm({
                header: 'Mensagem de Confirmação',
                message: `Atenção! Ao confirmar esta operação, a Prestação de Contas será enviada para Análise.
                    Deseja realmente confirmar esta operação?`,
                accept: () => {
                    this.observableUtilPanelDoc.setBlockedPanel(true);
                    this.service.EnviarPrestacaoConta(this.controller, { id: this.obj.id, id_situacao: 17, aceite: true }, { parcial: "id_situacao" })
                        .subscribe(() => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            if(this.funcao == 'cadastrar'){
                                this.router.navigate(['../'], { relativeTo: this.activatedRoute });
                            }else{
                                this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
                            }
                            return this.TratarMsgEnviarEditar(true);
                        },
                        err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false)
                            super.showMsgError(`Erro ao Enviar o Cadastro. ${err._body}`)
                        });
                }
            });
        });
        break;
      case "gerenciamentoEvento":
        this.service.Atualizar("edicaoEvento/AtualizarTermoAceiteLGPDEvento", itemSelecionado.id).subscribe(data => {
            let situacao = itemSelecionado.situacao == null ? null : itemSelecionado.situacao.id;
            this.enviarCadastroHomologacao(itemSelecionado, situacao);
            this.close();
        });
        break;
      case "edicaoEvento": 
        this.service.Atualizar("edicaoEvento/AtualizarTermoAceiteLGPD", itemSelecionado.id).subscribe(data => {
            if (event.button === "edicao_prestar_conta_homologacao"){
                if (itemSelecionado.id_tipo_certificacao == 2) {
                    this.router.navigate(['/atividades/edicao-evento/prestar-conta-homologacao', itemSelecionado.id], { relativeTo: this.activatedRoute });
                } else {
                    this.router.navigate(['/atividades/edicao-evento/prestar-conta-individual-homologacao', itemSelecionado.id], { relativeTo: this.activatedRoute });
                }
            }
            else{
                Number(itemSelecionado.id_tipo_certificacao) === 2 ?
                    this.router.navigate(['/atividades/edicao-evento/prestar-conta', itemSelecionado['id']], { relativeTo: this.activatedRoute })
                    : this.router.navigate(['/atividades/edicao-evento/prestar-conta-individual', itemSelecionado['id']], { relativeTo: this.activatedRoute });
            }
        });
        break;
      default:
        break;
    }

  }

  //se o termo nao for aceito (clicado no fechar) apenas fechar a tela e fica no ponto que estava.
  naoAceitarTermoLGPD(event: DatatableClickEvent){
    this.close();
  }

    TratarMsgEnviarEditar(enviar: boolean = false): void {
    return !this.profissionalEnviouAposPrazoInicial
        ? sessionStorage.setItem('msg', 'Registro salvo com sucesso.')
        : sessionStorage.setItem('msgWarn', `A sua prestação de contas foi ${(enviar ? 'enviada' : 'editada')} após
                                o dia 31 de janeiro de ${this.obj.exercicio}, portanto está intempestiva e
                                será analisada pelas Comissões de Educação Profissional Continuada do CFC/CRCs
                                quanto à intempestividade da entrega.`);
    }

    get profissionalEnviouAposPrazoInicial(): boolean {
        return this.ehProfissional &&
            this.DataSemHora(new Date()) > this.DataSemHora(new Date(this.obj.anoExercicio + 1, 0, 31))
    }


    enviarCadastroHomologacao(obj: any, situacao: any){
        let id_situacao: number;
        let propriedades: string[];
        let nome_perfil_receptor: string;
        if (situacao === Situacoes.Iniciado || situacao === Situacoes['Devolvido para Adequação']) {
            propriedades = ['id_situacao'];
        }
        if (situacao == Situacoes['Aberto para Recurso']) {
            nome_perfil_receptor = 'gestor crc';
            id_situacao = Situacoes['Aguardando análise no CRC - Gestor'];
        } else {
            obj['nome_pendencia_receptor'] ? nome_perfil_receptor = obj['nome_pendencia_receptor'] : nome_perfil_receptor = 'gestor crc';
            if (nome_perfil_receptor == 'gestor cfc') {
                id_situacao = Situacoes['Aguardando análise no CFC - Gestor']
            } else if (nome_perfil_receptor == 'gestor crc') {
                id_situacao = Situacoes['Aguardando análise no CRC - Gestor']
            } else if (nome_perfil_receptor == 'comissao crc') {
                id_situacao = Situacoes['Aguardando análise no CRC - Comissão']
            } else {
                id_situacao = Situacoes['Aguardando análise no CFC - Comissão']
            }
        }

        if (this.controller == 'gerenciamentoCurso') {
            this.homologacao_atividade = new HomologacaoCurso();
            this.homologacao_atividade.nome_perfil_receptor = nome_perfil_receptor;
            this.homologacao_atividade.id_curso = obj['id'];
            this.homologacao_atividade.curso = { id: obj['id'], id_situacao };
        } else if (this.controller == 'gerenciamentoEvento') {
            this.homologacao_atividade = new HomologacaoEvento();
            this.homologacao_atividade.nome_perfil_receptor = nome_perfil_receptor;
            this.homologacao_atividade.id_evento = obj['id'];
            this.homologacao_atividade.evento = { id: obj['id'], id_situacao };
        } 
        
        const questionamento = situacao === Situacoes['Aberto para Recurso'] ?
            'A atividade selecionada está aberta para recurso. Deseja realmente interpor recurso?' :
            'Deseja realmente enviar este registro?';
        this.observableUtilPanelDoc.setBlockedPanel(true);
        this.service.Adicionar(this.controller + "/verificarPrazo/", this.homologacao_atividade).subscribe(
            item => {

                this.observableUtilPanelDoc.setBlockedPanel(false);
                if (situacao !== Situacoes['Devolvido para Adequação']) {
                  if (item.prazoCapacitadoraAcabou && (this.controller === "gerenciamentoCurso" || this.controller === "gerenciamentoEvento")) {
                        this.showMsgWarn(`O prazo para envio das atividades do exercício de ${item.exercicio} está finalizado.`);
                        return;
                    }
                }
                this.confirmacao.confirm({
                    header: 'Confirmação',
                    message: questionamento,
                    accept: () => {
                        this.observableUtilPanelDoc.setBlockedPanel(true);

                        if (situacao === Situacoes['Aberto para Recurso']) {
                            this.router.navigate(['./abrir-recurso', obj['id']], { relativeTo: this.activatedRoute });
                        }
                        if (situacao !== Situacoes['Aberto para Recurso']) {
                            this.service.AtualizarAtividadeHomologacao(this.controller, this.homologacao_atividade, { parcial: propriedades }).subscribe(
                                () => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    window.location.reload();
                                    this.showMsgSucess(`Registro foi enviado com sucesso.`);
                                },
                                err => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    if (err.status === 412) {
                                        this.showMsgWarn(`Atenção.<br> ${err._body}`)
                                        return;
                                    }

                                    this.showMsgError(`Houve um erro ao enviar o registro. ${err}`)
                                });
                        }
                    },
                    reject: () => {
                        if (situacao === Situacoes['Aberto para Recurso']) {
                            this.naoAbrirRecurso(obj['id'], this.controller, true, 500);
                        }
                    }
                });
            }, err => {
                super.showMsg('error', 'Mensagem de Erro', `Houve um erro ao verificar o prazo do registro.<br> ${err._body}`)
                this.observableUtilPanelDoc.setBlockedPanel(false);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/Componentes/termo-aceite-lgpd/termo-aceite-lgpd.component.ts